import {
    all, put, takeLatest, select,
} from 'redux-saga/effects';

import { LOCATION_CHANGE } from 'connected-react-router';

import { extractQueryParameters } from 'helpers/RoutesHelpers';
import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import {
    setCurrentEventType,
    setCurrentPhone,
    setCurrentMessage,
    setCurrentQuestionType,
    setCurrentEmail,
    setCurrentName,
} from '../reduxModules/App';

import { getScopeSelector } from '../../commons/reduxModules/Authentication';

import Routes from '../constants/Routes';
import Scopes from '../../constants/Scopes';

export function* callAction() {
    const [
        scope,
        location,
    ] = yield all([
        select(getScopeSelector),
        select(getLocationSelector),
    ]);
    const searchParameters = extractQueryParameters(location.search);
    let param = searchParameters['support-modal'];
    // Reset the value when a form is displayed
    if (Scopes.USER === scope) {
        param = location.pathname;
    }

    window.scrollTo(0, 0);

    if ([
        Routes.CONTACT_SALESMAN.link,
        Routes.CONTACT_BY_EMAIL.link,
    ].indexOf(param) > -1) {
        yield all([
            put(setCurrentEventType('')),
            put(setCurrentPhone('')),
            put(setCurrentMessage(searchParameters.message || '')),
            put(setCurrentQuestionType('')),
            put(setCurrentEmail('')),
            put(setCurrentName('')),
        ]);
    }
}

export function* watch() {
    yield takeLatest(LOCATION_CHANGE, callAction);
}
